// extracted by mini-css-extract-plugin
module.exports = {"base":"Tooltip_base__yRFZT","top":"Tooltip_top__h2IIJ","bottom":"Tooltip_bottom__RW1vT","left":"Tooltip_left__7RKNM","right":"Tooltip_right__KBQ1H","show":"Tooltip_show__Eckia"};